import React, { Component } from 'react';
import { apiCall } from '../utils/api';
import Cookies from 'js-cookie';

class Login extends Component {
  state = {
    username: '',
    password: ''
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await apiCall('users/login', {
        username: this.state.username,
        password: this.state.password
      }, true);
      
      if (data.success) {
        Cookies.set('userToken', data.user.token, { expires: 7 });
        Cookies.set('userId', data.user.id, { expires: 7 });
        
        this.props.onLogin(data.user);
      }
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
    }
  }

  render() {
    return (
      <div className="card mt-3 bg-dark">
        <div className="card-body">
          <form onSubmit={this.handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="form-control bg-dark text-light"
                placeholder="Nom d'utilisateur"
                value={this.state.username}
                onChange={(e) => this.setState({ username: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="form-control bg-dark text-light"
                placeholder="Mot de passe"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Se connecter
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default Login; 